import type { LovCproDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import {
  getNaturesFichiersCpro as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/CPRO'
import { cproService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandeCPROStore = buildDemandeStore<'MODEL_CPRO', LovCproDTO>({
  model: 'MODEL_CPRO',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: cproService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})

